/**
 * WordPress dependencies
 */

/**
 * Internal dependencies
 */
// Blocks
import './blocks/qr';

// Plugins
import './plugins/qr-post';
import './plugins/post-publich-panel-qr-post';
